module.exports = __webpack_public_path__ + "static/media/ic_sec_real_estate.d548ba38.svg";